import { useEffect, useState } from 'react';

const states = ['Thinking…', 'Reviewing available machine evidence…', 'Checking grounded sources…'];

export function ThinkingState() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => setIndex((value) => Math.min(value + 1, states.length - 1)), 1300);
    return () => window.clearInterval(timer);
  }, []);
  return <div className="r42-thinking" role="status"><span className="r42-thinking-dots"><i /><i /><i /></span><span>{states[index]}</span></div>;
}
